import React from 'react';

import {
  Flex,
  Text,
} from '@chakra-ui/react';
import dayjs from 'dayjs';

import { FULL_DATETIME_FORMAT } from 'utils/dates';

import AddressInfo from './AddressInfo';
import DriverInfo from './DriversInfo';

interface GeneralInfoProps {
  data: any
  isExecution?: boolean
}

export default function GeneralInfo({ data = {}, isExecution = false }: GeneralInfoProps) {
  return (
    <Flex
      mb={8}
      mx={1}>
      <Flex
        width="60%"
        flexDir="column">
        <Text
          variant="mediumBold"
          color="gray.600">
          {data.partner?.name}
        </Text>
        <AddressInfo address={data.partner?.address ?? data.dispatchDestination?.address} />
        <Flex flexDir="column">
          <Text
            variant="xSmallSemiBold"
            mt={6}
            color="gray.500">Previsão:
          </Text>
          <Text
            variant="smallBold"
            color="gray.600">
            {dayjs(data.dueDate).format(FULL_DATETIME_FORMAT)}
          </Text>
        </Flex>
      </Flex>
      <Flex
        justifyContent="space-between"
        flexDir="column">
        <Flex flexDir="column">
          <DriverInfo
            initialKm={data.initialKm}
            finalKm={data.finalKm}
            drivers={data.drivers}
            vehicle={data.vehicle}
          />
        </Flex>
        <Flex
          hidden={!isExecution || !data.finishedAt}
          flexDir="column">
          <Text
            variant="xSmallSemiBold"
            mt={6}
            color="gray.500">Realizada às:
          </Text>
          <Text
            variant="smallBold"
            color="gray.600">
            {dayjs(data.finishedAt).format(FULL_DATETIME_FORMAT)}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
}
